var notificationsEllipsisInEnglish = ['loanApprovedStillProcessingNotify'];
var notificationsEllipsisInSpanish = [
    'loanApprovedStillProcessingNotify',
    'introRateLoanExpiringNotify'
];
export { notificationsEllipsisInEnglish, notificationsEllipsisInSpanish };
